<template>
  <div class="fee-warn-rules" data-test="fee-warn-rules">
    <div class="wrap">
      <div class="title">预警值设置</div>
      <div class="setting-box van-hairline--bottom">
        <div class="left t2">或</div>
        <div class="right">
          <van-field
            readonly
            label-width="160"
            input-align="right"
            type="digit"
          >
            <template #label>
              <div class="lab">
                剩余数量
                <div @click.stop="" class="popover-wrap">
                  <van-popover
                    v-model="showPopover1"
                    trigger="click"
                    placement="bottom-start"
                    theme="dark"
                    :offset="[-8, 4]"
                  >
                    剩余数量包括<br/>
                    1.按{{lessonUnit}}计费课程或课时包的剩余{{lessonUnit}}数<br/>
                    2.按天计费课程的剩余天数
                    <template #reference>
                      <van-icon name="question-o" class="tips-icon" />
                    </template>
                  </van-popover>
                </div>≤
              </div>
            </template>
            <template #input>
              <van-stepper
                v-model="params.remainAmount"
                min="0"
                max="999"
                integer
              />
            </template>
          </van-field>
          <van-field
            readonly
            label-width="160"
            input-align="right"
            type="digit"
          >
            <template #label>
              <div class="lab">
                剩余有效期天数
                <div @click.stop="" class="popover-wrap">
                  <van-popover
                    v-model="showPopover2"
                    trigger="click"
                    placement="bottom-start"
                    theme="dark"
                    :offset="[-8, 4]"
                  >
                    1.指按{{lessonUnit}}计费课程或课时包的有效期天数<br/>
                    2.当一个课程或课时包有多个购买订单时，将根据“剩余数量>0”的订单中有效期截止时间的最大值进行预警值判断（如存在有效期为“不限”的“剩余数量>0”的订单，则依据“不限”进行判断）
                    <template #reference>
                      <van-icon name="question-o" class="tips-icon" />
                    </template>
                  </van-popover>
                </div>≤
              </div>
            </template>
            <template #input>
              <van-stepper
                v-model="params.remainDay"
                min="0"
                max="999"
                integer
              />
            </template>
          </van-field>
        </div>
      </div>
      <div class="container">
        <span class="t2 mr">且</span>
        最近<van-field 
          class="cell-value-input"
          v-model="params.days" 
          type="digit"
          maxlength="3"
          placeholder="请输入"
          input-align="center"/>天累计提醒次数 ≤ &nbsp;
          <van-stepper
          v-model="params.noticeCount"
          min="0"
          max="999"
          integer
        />
      </div>
      <div class="title mg">自动提醒规则设置</div>
      <van-field label="自动发送续费提醒" label-width="160" input-align="right">
        <template #input>
          <van-switch v-model="params.autoNotice" size="20" :active-value="1" :inactive-value="0" @change="autoNoticeChange"/>
        </template>
      </van-field>
      <div class="title2">{{params.autoNotice?'系统将于09:00自动给满足提醒规则的学员发送续费提醒，停用后不再自动发送':'启用后，系统将于09:00自动给满足提醒规则的学员发送续费提醒'}}</div>
      <div class="container-wrap" v-if="params.autoNotice">
        <div class="t1">自动提醒规则</div>
        <div class="container">
          满足预警值，且最近&nbsp;<van-stepper
            v-model="params.autoDays"
            min="0"
            max="999"
            integer
          />&nbsp;天未发送过续费提醒
        </div>
        <div class="example" @click="showPopover = true">查看消息提醒示例</div>
      </div>
    </div>
    <page-footer-btn multipleBtns>
      <van-button square round block 
        @click="cancel" 
        data-test="fee-warn-rules-btn-cancel"
      >取消</van-button>
      <van-button square round block 
        type="primary" 
        @click="save" 
        data-test="fee-warn-rules-btn-save"
        :loading="submiting" 
        >保存</van-button>
    </page-footer-btn>

    <transition name="van-fade">
      <div class="example-layer" v-if="showPopover">
        <div class="example-body">
          <div class="title1">家长收到的微信消息示例：</div>
          <div class="title2">学员姓名、课程名称、到期时间、剩余数量，将根据实际情况推送。</div>
          <img
            class="non-full"
            src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0086.png"
            alt=""
          />
          <button @click="showPopover = false">我知道了</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import pageFooterBtn from "@x3/vue/comp/page-footer-btn.vue";

export default {
  name: "feeWarnRules",
  data() {
    return {
      pageTitle: "续费提醒规则",
      params: {
        autoDays: 30,
        autoNotice: 0,
        days: 0,
        noticeCount: 0,
        remainDay: 3,
        remainAmount: 3,
      },
      showPopover: false,
      showPopover1: false,
      showPopover2: false,
      submiting: false,
    };
  },
  computed: {
    ...Vuex.mapState(['lessonUnit']),
  },
  methods: {
    getDefaultDatas() { // 获取已有的配置
      this.showLoading();
      this.$api.findCompanyFeeWarnRule().then(res=> {
        if (res.code == 200) {
          Object.assign(this.params, res.data);
        }
      }).finally(()=>{        
        this.$toast.clear();
      });
    },
    autoNoticeChange(e) {
      if (e==1) {
        this.params.autoDays = 30;
      }
    },
    cancel() {
      this.$router.back();
    },
    save() {
      if (!this.params.days) {
        this.$toast.fail('请填写最近累计提醒天数。')
        return false;
      }
      this.showLoading();
      this.submiting = true;
      this.$api.feeWarnEditRule(this.params)
        .then(res=>{        
          this.submiting = false;
          if (res.code === 200) {                    
            app.vue.$emit("refresh-feeWarn-list");
            this.$toast.clear();     
            this.$toast.success('保存成功');
            this.$router.back();
            return false;
          }
          if (res.code > 60000) {
            this.$toast.fail(res.msg || '网络异常，请稍后重试');
          }
        })
        .catch(()=>{        
          this.submiting = false; 
        });
    }
  },
  created () {
    this.getDefaultDatas();
  },
  components: {
    pageFooterBtn
  }
}
</script>

<style lang="scss" scoped>
.fee-warn-rules {
  display: flex;
  flex-direction: column;
  .wrap {
    flex: 1;
    overflow-y: auto;
    .title {
      margin: calc(var(--gap) * 16) calc(var(--gap) * 16) calc(var(--gap) * 8) calc(var(--gap) * 16);
      color: var(--g7);
      font-size:var(--fs-md);
      line-height:var(--lh-md);
      &.mg {
        margin-top: calc(var(--gap) * 32);
      }
    }
    .title2 {
      margin: calc(var(--gap) * 8) calc(var(--gap) * 16) calc(var(--gap) * 16) calc(var(--gap) * 16);
      color: var(--g6);
      font-size:var(--fs-md);
      line-height:var(--lh-md);
    }
    .setting-box {
      display: flex;
      align-items: center;
      background-color: var(--white);
      .left {
        position: relative;
        margin-left: calc(var(--gap) * 16);
        flex-shrink: 0;
        &:before,
        &:after {
          content: '';
          display: block;
          width: 8px;
          height: 12px;
          border: 1px solid #DCDEE0;
          position: absolute;
          left: 8px;
        }
        &:before {
          top: -18px;
          border-right: 0;
          border-bottom: 0;
        }
        &:after {
          top: 25px;
          border-right: 0;
          border-top: 0;
        }
      }
      .right {
        flex: 1;
      }
    }
    .lab {
      display: flex;
      align-items: center;
      ::v-deep .van-popover__wrapper {
        display: flex;
        align-items: center;
        padding-left: 2px;
      }
    }
    .container {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      color: var(--g7);
      background-color: var(--white);
      padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
      .cell-value-input{
        padding: 0;
        margin: 0 calc(var(--gap) * 5);
        border-radius: var(--radius-base);
        background-color: var(--g2);
        width: calc(var(--w) * 40);
        // font-size:var(--fs-lg);
        line-height:var(--lh-ex2);
        input {
          padding: calc(var(--gap) * 3) calc(var(--gap) * 8);
        }
      }
    }
    .container-wrap {
      .t1 {
        padding: calc(var(--gap) * 12) calc(var(--gap) * 16) 0 calc(var(--gap) * 16);
        background-color: var(--white);
      }
      .example {
        margin: calc(var(--gap) * 8) calc(var(--gap) * 16);
        color: var(--c1);
      }
    }
  }
  .t2 {
    font-size:var(--fs-md);
    line-height:var(--lh-md);
    color: var(--g6);
    &.mr {
      margin-right: calc(var(--gap) * 16);
    }
  }
  .example-layer {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.9);
    .example-body {
      position: absolute;
      top: 50%;
      width: 100%;
      transform: translateY(-50%);
      .title1 {
        margin: 0 calc(var(--gap) * 16);
        color: var(--white);
        font-size:var(--fs-lg);
        line-height:var(--lh-lg);
      }
      .title2 {
        margin: calc(var(--gap) * 8) calc(var(--gap) * 16) calc(var(--gap) * 16) calc(var(--gap) * 16);
        font-size:var(--fs-md);
        line-height:var(--lh-md);
        color: var(--white);
      }
      img {
        width: 100%;
        height: auto;
        &.non-full {
          display: block;
          width: 90%;
          margin: 0 auto;
        }
      }
      button {
        display: block;
        margin: calc(var(--gap) * 40) auto 0;
        padding: calc(var(--gap) * 8) calc(var(--gap) * 40);
        color: var(--white);
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        background-color: transparent;
        border-radius: var(--radius-lg);
        border: 1px solid #ffffff;
        box-shadow: unset;
      }
    }
  }
}
</style>